// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"5ff8c540","324":"5a5d7054","391":"2b05a4d2","416":"f73ab437","697":"79873ef8","786":"b00c6ddf","791":"f101e5e9","875":"8ed6d8e0"}[chunkId] + ".chunk.js";
};